export default __webpack_public_path__ + "static/sc-lobbyst2-895701bd4622bfc25d07f8c99ccada20.webp";